import { render } from "./Bulkactions.vue?vue&type=template&id=4d29d774&scoped=true"
import script from "./Bulkactions.vue?vue&type=script&lang=js"
export * from "./Bulkactions.vue?vue&type=script&lang=js"

import "./Bulkactions.vue?vue&type=style&index=0&id=4d29d774&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d29d774"]])

export default __exports__